module.exports = __webpack_public_path__ + "img/healthcare.286af6bd.jpg";